<template>
  <div>
    <div class="e-input-group m-b-8">
      <input class="e-input" type="text" v-model="searchData" @keyup.enter="querySearchClick"/>
      <span class="icon hero-icon hero-icon-search" @click="querySearchClick"></span>
    </div>
    <div class="h-scroll h100-80">
      <div class="h-toolbarBg">
        <ejs-toolbar ref="toolbar">
          <e-items>
            <e-item prefixIcon='icon hero-icon hero-icon-advanced-search' :tooltipText='$t("Pm.queryInfo")' :click="dataQuery" operate='search'></e-item>
            <e-item prefixIcon='icon hero-icon hero-icon-quick-export' :tooltipText='$t("Pm.quickExport")' :click="quickExport" operate='quickExport'></e-item>
            <e-item prefixIcon='icon hero-icon hero-icon-batch-export' :tooltipText='$t("Pm.batchExport")' :click="batchExport" operate='batchExport'></e-item>
          </e-items>
        </ejs-toolbar>
      </div>
      <MeasureTreeForNoRealQuery ref="MeasureTreeForNoRealQuery" @transferMeasureObjForQuery="transferMeasureObjForQuery"></MeasureTreeForNoRealQuery>
    </div>
  </div>
</template>

<script>
import MeasureTreeForNoRealQuery from './tree/MeasureTreeForNoRealQuery';

export default {
  name: 'NoRealQueryManagementPage',
  components: {
    MeasureTreeForNoRealQuery
  },
  data() {
    return {
      searchData: ''
    };
  },
  methods: {

    // 按条件搜索
    querySearchClick() {
      this.$refs.MeasureTreeForNoRealQuery.getMeasureObjectTreeForQuery(this.searchData);
    },

    // 数据查询
    dataQuery() {
      this.$parent.$parent.showNoRealQuerySearchDialog1();
    },

    // 快捷导出
    quickExport() {
      this.$parent.$parent.showQuickExportDialog();
    },

    // 批量导出
    batchExport() {
      this.$parent.$parent.showBatchExportDialog();
    },

    // 测量对象树点击处理
    transferMeasureObjForQuery(node) {
      let CounterTypeId = '';
      let MeasureObjectTypeCode = '';
      let NeTypeId = '';
      const nodeData = this.$refs.MeasureTreeForNoRealQuery.$refs.measureTreeForNoRealQuery.getTreeData(node.nodeData.id)[0];
      const attribute = nodeData.attributes;
      if (attribute) {
        NeTypeId = attribute.neTypeId ? attribute.neTypeId : '';
        MeasureObjectTypeCode = attribute.measureObjectTypeCode ? attribute.measureObjectTypeCode : '';
        CounterTypeId = attribute.counterTypeId ? attribute.counterTypeId : '';

        // 如果是测量对象节点，获取父节点和根节点的文本信息
        if (attribute.counterTypeId) {
          const parentNode = this.$refs.MeasureTreeForNoRealQuery.$refs.measureTreeForNoRealQuery.getTreeData(node.nodeData.parentID)[0];
          const rootNode = this.$refs.MeasureTreeForNoRealQuery.$refs.measureTreeForNoRealQuery.getTreeData(parentNode.parentId)[0];

          // 点击测量对象基本信息事件发布
          this.$emit('textObjChange', {
            nodeText: nodeData.text,
            parentText: parentNode.text,
            rootText: rootNode.text
          });
        }
      }
      const params = {
        measureObjectTypeCode: MeasureObjectTypeCode,
        counterTypeId: CounterTypeId,
        neTypeId: NeTypeId
      };

      // 根据选择节点是否为树中的测量对象节点来切换工具图标的显隐
      if (params.counterTypeId == '') {
        this.$refs.toolbar.enableItems([2], true);
        this.$refs.toolbar.enableItems([0, 1], false);
      } else {
        this.$refs.toolbar.enableItems([2], false);
        this.$refs.toolbar.enableItems([0, 1], true);
      }

      // 测量对象树选中节点信息发布
      this.$emit('transferMeasureObjForSearch', nodeData);
    }
  },
  mounted() {
    // 初始化默认取消所有按钮点击权限
    this.$refs.toolbar.enableItems([0, 1, 2], false);
  }
};
</script>

<style>

</style>
